<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <h1>Status</h1>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-btn-toggle v-model="statsView" mandatory dense>
          <v-btn value="total" small>Total</v-btn>
          <v-btn value="byProject" small>By project</v-btn>
        </v-btn-toggle>
      </v-col>
    </v-row>

    <v-row v-if="statsView === 'total'">
      <v-col cols="6" md="3">
        <v-card outlined class="text-center">
          <v-card-title class="headline justify-center">{{ untaggedCount }}</v-card-title>
          <v-card-subtitle>Untagged</v-card-subtitle>
        </v-card>
      </v-col>
      <v-col cols="6" md="3">
        <v-card outlined class="text-center">
          <v-card-title class="headline justify-center">{{ taggedCount }}</v-card-title>
          <v-card-subtitle>Tagged</v-card-subtitle>
        </v-card>
      </v-col>
    </v-row>

    <v-row v-else>
      <v-col cols="12" md="8">
        <v-simple-table v-if="byProject.length > 0">
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">Project ID</th>
                <th class="text-right">Untagged</th>
                <th class="text-right">Tagged</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="row in byProject" :key="row.project_id">
                <td>{{ row.project_id }}</td>
                <td class="text-right">{{ row.untagged_count }}</td>
                <td class="text-right">{{ row.tagged_count }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
        <p v-else class="text-left grey--text">No project stats available.</p>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" md="8">
        <h2 class="mb-2">Checked Out Images</h2>
        <v-simple-table v-if="checkedOutUsers.length > 0">
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">User</th>
                <th class="text-left">Checked Out</th>
                <th class="text-left">Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="row in checkedOutUsers" :key="row.user_id">
                <td>{{ row.user_name }}</td>
                <td>{{ row.checked_out_count }}</td>
                <td>
                  <v-btn small color="warning" @click="doUnassign(row.user_id)">
                    Unassign
                  </v-btn>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
        <p v-else class="text-left grey--text">No users have checked out images.</p>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  name: "Status",
  data() {
    return {
      statsView: "total",
    };
  },
  computed: {
    ...mapState({
      untaggedCount: (state) => state.status.untaggedCount,
      taggedCount: (state) => state.status.taggedCount,
      checkedOutUsers: (state) => state.status.checkedOutUsers,
      byProject: (state) => state.status.byProject,
    }),
  },
  mounted() {
    this.fetchStatus();
  },
  methods: {
    ...mapActions(["fetchStatus", "unassignUser"]),
    doUnassign(userId) {
      this.unassignUser(userId);
    },
  },
};
</script>
